<template lang="pug">
v-text-field(
    v-bind="$attrs"
    v-on="$listeners"
    :rules="hostRules"
    label='Http Path'
    data-track="http-path"
    dense clearable outlined required)

</template>

<script lang="ts">
import isConvertibleToNotBlankString from '@/utils/isConvertibleToNotBlankString';
import { Vue, Component } from 'vue-property-decorator';

@Component
export default class InputHttpPath extends Vue {
  hostRules = [(v: string) => isConvertibleToNotBlankString(v) || 'Http Path is required'];
}
</script>
